<template>
  <div>
    <v-row justify="end" no-gutters>
      <v-col cols="12" sm="8" md="6">
        <v-row align="center" no-gutters>
          <v-col cols="12" sm="6" class="text-right">
            <v-btn class="ml-0 mr-4 mb-3" text @click="toggleAdvancedSearch">{{ toggleLabel }}</v-btn>
          </v-col>
          <v-col cols="12" sm="6" class="text-right">
            <SingleSearchFilter :context="context" :disabled="advancedSearch" :fields="searchFields" />
          </v-col>
        </v-row>
      </v-col>

      <v-slide-y-transition class="py-0">
        <v-col cols="12" v-if="advancedSearch">
          <SearchSelector :context="context" />
          <AdvancedSearchRow :context="context" :fields="searchFields" />
        </v-col>
      </v-slide-y-transition>
      <v-col cols="12"> <AdvancedSearchSummary :context="context" /> </v-col>
    </v-row>
  </div>
</template>

<script>
import { SingleSearchFilter, AdvancedSearchRow, AdvancedSearchSummary, SearchSelector } from '@argon/app/components'

export default {
  name: 'SearchBar',
  components: {
    SingleSearchFilter,
    AdvancedSearchRow,
    AdvancedSearchSummary,
    SearchSelector
  },
  props: {
    searchFields: { type: Array, default: () => [{ label: 'display', type: 'text' }] },
    context: { type: String, required: true }
  },
  data: () => ({
    advancedSearch: false
  }),
  computed: {
    toggleLabel() {
      return this.advancedSearch ? `${this.$t('labels.hideFilters')}` : `${this.$t('labels.showFilters')}`
    }
  },
  methods: {
    toggleAdvancedSearch() {
      this.advancedSearch = !this.advancedSearch
    }
  }
}
</script>
